import { AssignmentLaxSchema } from '@eigtech/assignments-types';
import { z } from 'zod';
export const JobAssignedEventDetailsSchema = AssignmentLaxSchema.omit({
    requestActor: true,
});
export const JobUnassignedEventDetailsSchema = z.object({
    assignableId: z.string(),
    assigneeId: z.string(),
});
